module.exports = __webpack_public_path__ + "img/p5.ca62ae5.png";